import React, { useEffect, useState } from 'react';
import {
  InputWrapper,
  Quest,
  QuestContainer,
  CheckboxContainer,
  Row,
  Name,
  For,
  OptionContainer,
  QuestionTextContainer,
} from './Restrictions.styles';
import Input from '../../utils/Input/Input';
import Button from '../../utils/Button/Button';
import { useNavigate } from 'react-router-dom';
import CheckboxInput from '../../utils/CheckboxGuest/CheckboxInput';
import FormContainer from '../../utils/FormContainer/FormContainer';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCreateGuestAnswersPending,
  selectGuestAnswers,
  selectGuestFlow,
  selectInvitationGuestMembers,
  selectRSVPInfo,
  setCurrentGuestIdAndFinished,
  setGuestQuestionAnswersAndFinish,
} from '../../../store/slice/rsvp/slice';
import { QUESTION_TYPE } from '../../../utils/constants';
import { createGuestAnswers } from '../../../store/slice/rsvp/asyncThunks';

const Restrictions = ({ rsvpKey }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [restriction, setRestriction] = useState('');
  const [selectedAnswers, setSelectedAnswers] = useState([]);

  const guestAnswers = useSelector(selectGuestAnswers);
  const rsvp = useSelector(selectRSVPInfo);
  const guestFlow = useSelector(selectGuestFlow);
  const { data } = useSelector(selectInvitationGuestMembers);
  const createGuestAnswersPending = useSelector(selectCreateGuestAnswersPending);

  const onContinue = () => {
    const isAnyoneConfirmed = guestAnswers.find(
      guest => guest.confirm === true && guest.finished === false && guest.id !== guestFlow.currentGuestOnFlowId,
    );
    if (guestFlow.finished === data.length - 1 || !isAnyoneConfirmed) {
      const setData = {
        id: data[0].guestInvitationId,

        body: {
          guestMembers: guestAnswers.map(i => {
            if (i.id === guestFlow.currentGuestOnFlowId) {
              return { ...i, answers: selectedAnswers };
            }
            return i;
          }),
        },
      };
      dispatch(createGuestAnswers(setData))
        .unwrap()
        .then(() => {
          const query = { key: rsvpKey, step: 'SEEYASOON', answer: 'ACCEPTED' };
          const queryString = new URLSearchParams(query).toString();
          const url = `/wedding-guest?${queryString}`;

          navigate(url);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      dispatch(setGuestQuestionAnswersAndFinish({ id: guestFlow.currentGuestOnFlowId, selectedAnswers }));

      // const isAnyoneConfirmed = guestAnswers.find(
      //   guest => guest.confirm === true && guest.finished === false && guest.id !== guestFlow.currentGuestOnFlowId,
      // );
      // console.log(isAnyoneConfirmed);
      if (isAnyoneConfirmed) {
        const index = guestAnswers.findIndex(
          guest => guest.confirm === true && guest.finished === false && guest.id !== guestFlow.currentGuestOnFlowId,
        );
        dispatch(
          setCurrentGuestIdAndFinished({
            currentGuestOnFlowId: isAnyoneConfirmed.id,
            finished: index,
          }),
        );
        const query = { key: rsvpKey, step: 'CONFIRMATION' };
        const queryString = new URLSearchParams(query).toString();
        const url = `/wedding-guest?${queryString}`;
        navigate(url);
      }
    }
  };

  const handleGuestAnswerSelect = (answerOption, question) => {
    setSelectedAnswers(prev => {
      const exists = prev.find(answer => answer.questionOptionId === answerOption.id);
      if (!exists) {
        let filterAll = prev.filter(question => question.type !== QUESTION_TYPE.MULTIPLE);
        return [...filterAll, { questionOptionId: answerOption.id, type: question.type }];
        //return [...prev, { questionOptionId: answerOption.id, type: question.type }];
      } else {
        return prev.filter(question => question.questionOptionId !== answerOption.id);
      }
    });
  };

  const handleTextAnswer = (answerOption, question, text) => {
    setSelectedAnswers(prev => {
      const exists = prev.find(answer => answer.questionOptionId === answerOption.id);
      if (!exists) {
        return [...prev, { questionOptionId: answerOption.id, type: question.type, text }];
      } else {
        return (prev = prev.map(answer => {
          if (answer.questionOptionId === answerOption.id) {
            return { ...answer, text: text };
          }

          return answer;
        }));
      }
    });
  };
  const isChecked = answerOptionId => {
    const exist = selectedAnswers.find(answer => answer.questionOptionId === answerOptionId);
    return !!exist;
  };
  const getOptionText = answerOptionId => {
    const exist = selectedAnswers.find(answer => answer.questionOptionId === answerOptionId);
    return exist?.text;
  };

  const isDisable = () => {
    let founded = false;
    let isFilled = true;
    const existMultipleQuestion = rsvp.questions.find(q => q.type === QUESTION_TYPE.MULTIPLE);
    for (const question of rsvp.questions) {
      if (existMultipleQuestion) {
        if (question.type === QUESTION_TYPE.MULTIPLE) {
          for (const option of question.questionOptions) {
            const exist = selectedAnswers.find(answer => answer.questionOptionId === option.id);
            if (exist) {
              founded = true;
            }
          }
        }
      } else {
        founded = true;
        if (question.type === QUESTION_TYPE.TEXT) {
          const exist = selectedAnswers.find(answer => answer.questionOptionId === question.questionOptions[0].id);
          if (!exist || !exist.text) {
            isFilled = false;
          }
        }
      }
    }
    return isFilled && founded;
  };

  return (
    <FormContainer message={'Just a few more things..'}>
      <InputWrapper>
        <Row>
          <For>For:</For>
          <Name>
            {data.length
              ? data[guestFlow.finished].firstName + ' ' + data[guestFlow.finished].lastName
              : 'Name not found'}
          </Name>
        </Row>
      </InputWrapper>
      {rsvp.questions.length > 0 &&
        rsvp.questions.map(quest => {
          return (
            <div key={quest.id}>
              {quest.type === QUESTION_TYPE.TEXT ? (
                <InputWrapper>
                  <Quest>{quest.question}</Quest>
                  <Input
                    placeholder={'Enter Your Answer'}
                    value={
                      getOptionText(quest.questionOptions[0]?.id) ? getOptionText(quest.questionOptions[0].id) : ''
                    }
                    onChange={e => handleTextAnswer(quest.questionOptions[0], quest, e.target.value)}
                  />
                </InputWrapper>
              ) : (
                <CheckboxContainer>
                  <QuestContainer key={quest.id}>
                    <QuestionTextContainer>
                      <Quest>{quest.question}</Quest>
                    </QuestionTextContainer>

                    {quest.questionOptions.map(a => (
                      <OptionContainer key={a.id}>
                        <CheckboxInput
                          key={a.id}
                          onClick={() => handleGuestAnswerSelect(a, quest)}
                          checked={isChecked(a.id)}
                          label={a.name}
                        />
                      </OptionContainer>
                    ))}
                  </QuestContainer>
                </CheckboxContainer>
              )}
            </div>
          );
        })}

      <Button
        title={'Continue'}
        disabled={!isDisable()}
        onClick={onContinue}
        width
        loading={createGuestAnswersPending}
        isWhite
      />
    </FormContainer>
  );
};

export default Restrictions;
